import {Button} from '@progress/kendo-react-buttons'
import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import * as React from 'react'
import {connect} from 'react-redux'
import * as ReactStrap from 'reactstrap'
import * as Redux from 'redux'
import * as App from '../../app/types'
import * as Breadcrumb from '../../components/breadcrumbs'
import * as DetailPanel from '../../components/detail-panel'
import { FlashMessage } from '../../components/flash-message'
import * as Help from '../../components/help'
import * as IsActive from '../../components/is_active'
import * as Link from '../../components/link'
import { Loading } from '../../components/loading'
import * as Menu from '../../components/menu/left-nav'
import * as UserMenu from '../../components/menu/user-menu'
import * as RasaModal from '../../components/modal'
import * as RasaInput from '../../components/rasa-input'
import * as Sortable from '../../components/sortable'
import * as User from '../../components/user'
import * as FilterGroup from '../filter-group'
import * as GridCell from '../grid-cell'
import * as Reference from '../reference'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Render from './render'
import './styles.css'
import * as Types from './types'
import * as Utils from './utils'

const {Row, Col} = ReactStrap

const breadcrumbs: Breadcrumb.Breadcrumbs = Menu.breadcrumbs(Menu.CONTENT_SOURCES_URL)

interface AppProps {
  app: App.State,
  referenceData?: Reference.CategoryProps,
  sources?: Types.WrappedState,
  helpText?: string,
}

interface SubmitAddProps {
  submitModal: RasaModal.Submit<Types.AddSourceData>
}

type AddModalProps =
  RasaModal.ComponentState<Types.AddSourceData> &
  RasaModal.DispatchState &
  SubmitAddProps &
  AppProps

const AddModal = ({app, modal, referenceData, submitModal, showModal, updateModal}: AddModalProps) =>
<ReactStrap.Modal className="modal-lg" isOpen={modal.isOpen} toggle={showModal}>
  <form className="k-form add-source-form">
    <ReactStrap.ModalHeader toggle={showModal}>Enter new Source</ReactStrap.ModalHeader>
    <ReactStrap.ModalBody>
      <FlashMessage />
      <Breadcrumb.BreadcrumbComponent breadcrumbs={breadcrumbs}/>
      <RasaInput.RasaInput label="Source Name"
                           placeholder=""
                           value={modal.data.name}
                           validation={RasaInput.validateTitle(modal.data.name)}
                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                           updateModal({name: 'name', value: e.target.value})} />
      <RasaInput.RasaInput label="URL"
                           placeholder=""
                           value={modal.data.identifier}
                           validation={Utils.validateIdentifier(modal.data)}
                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                           updateModal({name: 'identifier', value: e.target.value})} />
      <Row>
        <Col>
          <RasaInput.RasaSelectInput label="Content Type"
                        helpType="source-config-subscription-type"
                        value={modal.data.content_type}
                        options={Reference.subscriptionTypesByName()}
                        onChange={(e: any) => updateModal({
                          name: 'content_type', value: e.target.value})}/>
        </Col>
        <Col>
          <RasaInput.RasaSelectInput label="Source Type"
                          helpType="source-config-source-type"
                          value={modal.data.source_type}
                          options={Reference.sourceTypesByName()}
                          onChange={(e: any) => updateModal({
                            name: 'source_type', value: e.target.value})}/>
        </Col>
      </Row>
      <Row>
        <Col>
          <RasaInput.RasaSelectInput label="Content Category"
                            helpType="source-config-category"
                            value={modal.data.category_type}
                            options={Reference.dropdownTypesByName(
                              referenceData.categories || Reference.SUBSCRIPTION_CATEGORIES)}
                            onChange={(e: any) => updateModal({
                              name: 'category_type', value: e.target.value})}/>
        </Col>
        <Col>
          <RasaInput.RasaNumericInput label="Weight"
                          helpType="source-config-weighting"
                          placeholder="Numeric Value"
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            updateModal({ name: 'weight', value: e.target.value })}
                          value={modal.data.weight} />
        </Col>
      </Row>
    </ReactStrap.ModalBody>
    <ReactStrap.ModalFooter>
      {modal.isSubmitting ? <Loading size={Loading.Sizes.SMALL} /> : <span/>}
      <Button color="primary"
              disabled={modal.isSubmitting || !Utils.addModalStateValid(modal.data)}
              onClick={() => submitModal(app.selectedCommunity, modal.data)}>
        Save
      </Button>
      <Button onClick={showModal}>Cancel</Button>
    </ReactStrap.ModalFooter>
  </form>
</ReactStrap.Modal>

const AddModalConnect = connect(
  ({app, referenceData, sources}: AppProps & Types.WrappedState) =>
  ({app, referenceData, modal: sources.modalAddSource}),
  {
    showModal: Actions.toggleAddSourceModal,
    submitModal: Actions.create,
    updateModal: Actions.updateAddSourceModalField,
  },
)(AddModal)

interface SubmitImportProps {
  submitModal: RasaModal.Submit<Types.ImportSourceData>
}

type ImportModalProps =
  RasaModal.ComponentState<Types.ImportSourceData> &
  RasaModal.DispatchState &
  SubmitImportProps &
  AppProps

const FileImportModal = ({app, helpText, modal, showModal, submitModal, updateModal}: ImportModalProps) =>
  <ReactStrap.Modal className="modal-lg" isOpen={modal.isOpen} toggle={showModal}>
    <form className="k-form" onSubmit={Link.preventDefault()} >
      <ReactStrap.ModalHeader toggle={showModal}>{modal.modalTitle || 'Import'}</ReactStrap.ModalHeader>
      <ReactStrap.ModalBody>
        {modal.data.message !== '' ? <div className="alert alert-success">{modal.data.message}</div> : ''}
        <span dangerouslySetInnerHTML={{ __html: helpText}}></span>
        <label className="k-form-field">
          <input
            type="file" accept=".csv"
            className="k-textbox"
            placeholder="File to import"
            onChange = {(e) => RasaModal.handleCsvFileChange(
              updateModal,
              Utils.sourceImportValidator,
              e.target.files)
            }
          />
        </label>
      </ReactStrap.ModalBody>
      <ReactStrap.ModalFooter>
        <Help.Help id="import-csv-help" helpType={'import-csv-help'} />
        {modal.isSubmitting ? <Loading size={Loading.Sizes.SMALL} /> : <span/>}
        <Button color="primary" disabled={modal.isSubmitting || !Utils.importModalStateValid(modal.data)}
                onClick={() => submitModal(app.selectedCommunity, modal.data)}>
          Save
        </Button>
        <Button onClick={showModal}>Cancel</Button>
      </ReactStrap.ModalFooter>
    </form>
  </ReactStrap.Modal>

const ImportSourceModal = connect(
  ({app}: AppProps) => ({app}),
  ({
    showModal: Actions.toggleImportModal,
    submitModal: Actions.uploadSourceCsv,
    updateModal: Actions.updateImportModalField,
  }),
)(FileImportModal)

interface HeaderProps {
  exportSources: Actions.ExportSources,
  showAddModal: RasaModal.Toggle,
  showAddFilterModal: RasaModal.Toggle,
  showImportModal: RasaModal.Toggle,
}

const Header = ({app, sources, exportSources, showAddModal, showAddFilterModal, showImportModal, view}:
  AppProps & Types.WrappedState & HeaderProps & Types.WrappedViewState) =>
<div>
  <FlashMessage />
  <Breadcrumb.BreadcrumbComponent breadcrumbs={breadcrumbs}/>
  <ReactStrap.Row className="margin-auto">
    <ReactStrap.Col sm="12" md="10" className="text-left page-header--padding">
      <div className="page-header">
        <span className="title">Sources</span>
        <Button
          disabled={view.isLoading}
          className="secondary-button"
          onClick={showImportModal}
          title="Import Sources">
          Import
        </Button>
        <Button
          disabled={view.isLoading}
          className="secondary-button"
          onClick={showAddModal}
          title="Add Source">
          Add
        </Button>
        <Button
          disabled={view.isLoading}
          className="secondary-button"
          onClick={showAddFilterModal}
          title="Add Filter Group">
          Add Filter Group
        </Button>
        {
          sources.export.isExportLoading
          ?
            <Loading className="margin-left--5" center size={Loading.Sizes.SMALL} />
          :
          <Button
            disabled={view.isLoading || sources.data.length === 0}
            className="secondary-button show-disabled-tooltip"
            onClick= {() => exportSources(app.selectedCommunity)}
            title="Export Sources">
            Export
          </Button>
        }
      </div>
    </ReactStrap.Col>
    <ReactStrap.Col sm="12" md="2">
      <div className="page-header--padding">
        <IsActive.FilterSelect view={view} event={Constants.FETCH_SOURCES} disabled={view.isLoading}/>
      </div>
    </ReactStrap.Col>
  </ReactStrap.Row>
</div>

const HeaderConnect = connect(
  ({app, sources}: AppProps & Types.WrappedState) => ({app, sources}),
  ({
    exportSources: Actions.exportSources,
    showAddFilterModal: Actions.toggleAddFilterModal,
    showAddModal: Actions.toggleAddSourceModal,
    showImportModal: Actions.toggleImportModal,
  }),
)(Header)

interface DispatchProps {
  dispatch: Redux.Dispatch<Redux.Action>
}
type Props = Types.WrappedState & DispatchProps & UserMenu.WrappedState & App.WrappedState
const detailPanelActions = DetailPanel.createActionsMap(Constants.PAGE_PREFIX)

const SmallAndMediumGrid = ({sources, dispatch, userMenu}: Props) =>
<div>
  {sources.data.length > 0 ?
    <Grid data={sources.data}
          resizable={true}
          sortable={{
          allowUnsort: true,
          mode: 'multiple',
          }}
          sort={sources.view.sort}
          onRowClick={({dataItem}) => dispatch(detailPanelActions[DetailPanel.OPEN](dataItem))}
          onSortChange={(e: GridSortChangeEvent) => dispatch({
                              options: { value: e.sort },
                              type: Sortable.sortTableConstant(Constants.FETCH_SOURCES),
          })}>
      <GridColumn cell={Render.ActiveCell} field="is_active" title="Active" width={75}/>
      <GridColumn cell={Render.SourceCell} field="name" title="Source" width={150}/>
      <GridColumn cell={GridCell.TypeCell} field="subscription_type_sortable" title="Type" width={75}/>
      <GridColumn field="last_week_post_counts" title="Posts" width={75}/>
  </Grid>
    : <div>No sources currently setup, please add one</div>}
</div>

const SmallAndMediumGridConnected = connect(
  ({sources, userMenu, app}: Props) => ({sources, userMenu, app}),
  (dispatch: any) => ({dispatch}),
  )(SmallAndMediumGrid)

const LargeGrid = ({sources, dispatch, userMenu}: Props) =>
  <div>
  {sources.data.length > 0 ?
        <Grid data={sources.data}
              resizable={true}
              sortable={{
              allowUnsort: true,
              mode: 'multiple',
              }}
              sort={sources.view.sort}
              onRowClick={({dataItem}) => dispatch(detailPanelActions[DetailPanel.OPEN](dataItem))}
              onSortChange={(e: GridSortChangeEvent) => dispatch({
                            options: { value: e.sort },
                            type: Sortable.sortTableConstant(Constants.FETCH_SOURCES),
              })}>
    <GridColumn cell={Render.ActiveCell} field="is_active" title="Active" width={75}/>
    <GridColumn cell={Render.SourceCell} field="name" title="Source" width={250}/>
    <GridColumn cell={GridCell.TypeCell} field="subscription_type_sortable" title="Type" width={75}/>
    <GridColumn field="category_type" title="Category" width={150}/>
    <GridColumn field="last_week_post_counts" title="Posts" width={75}/>
    {userMenu && User.isBetaUser(userMenu.user) &&
    <GridColumn cell={GridCell.QualityCell} field="last_week_quality_score" title="Avg. Quality" width={75}/>
    }
    <GridColumn cell={GridCell.DateTimeCell} field="created_datetime" title="Created"/>
    <GridColumn cell={GridCell.DateTimeCell} field="last_success_datetime" title="Last Load" width={225} />
  </Grid>
    : <div>No sources currently setup, please add one</div>}
</div>

const LargeGridConnected = connect(
  ({sources, userMenu, app}: Props) => ({sources, userMenu, app}),
  (dispatch: any) => ({dispatch}),
)(LargeGrid)

export const SourceGrid = ({sources, dispatch, userMenu, app}: Props) =>
<div className="sources-page">
  <ReactStrap.Row>
    <ReactStrap.Col>
      <HeaderConnect view={sources.view}/>
    </ReactStrap.Col>
  </ReactStrap.Row>
  <div className="grid">
    {sources.view.isLoading
      ?
        <Loading center size={Loading.Sizes.LARGE} />
      :
      <Row>
        <Col>
          {app.viewport.isLarge ? <LargeGridConnected/> : <SmallAndMediumGridConnected/>}
        </Col>
    </Row>
    }
  </div>
  { sources.detailPanel.isOpen &&
    <DetailPanel.DetailPanel>
      <span>
        {sources.detailPanel.data &&
          <span>
            <Button icon="close" className="close"
              onClick={() => dispatch(detailPanelActions[DetailPanel.CLOSE](null))}/>
            <Row>
              <Col sm="12" md="4">
                <Row>
                  <Col sm="2">Name:</Col>
                  <Col>{sources.detailPanel.data.name}</Col>
                </Row>
                <Row>
                  <Col sm="2">Url:</Col>
                  <Col>{sources.detailPanel.data.source_url}</Col>
                </Row>
                <Row>
                  <Col sm="2">Type:</Col>
                  <Col>{sources.detailPanel.data.subscription_type}</Col>
                </Row>
                <Row>
                  <Col sm="2">Active:</Col>
                  <Col>{sources.detailPanel.data.is_active ? 'Yes' : 'No'}</Col>
                </Row>
                <Row>
                  <Col sm="2">Gated:</Col>
                  <Col>{sources.detailPanel.data.is_gated ? 'Yes' : 'No'}</Col>
                </Row>
              </Col>
              <Col sm="12" md="4">
                <Row>
                  <Col sm="6">Min Posts Count:</Col>
                  <Col>{sources.detailPanel.data.newsbrief_count}</Col>
                </Row>
                <Row>
                  <Col sm="6">Min Tag Count:</Col>
                  <Col>{sources.detailPanel.data.minimum_tag_count}</Col>
                </Row>
                <Row>
                  <Col sm="6">Weight:</Col>
                  <Col>{sources.detailPanel.data.weight}</Col>
                </Row>
                <Row>
                  <Col sm="6">Clicks:</Col>
                  <Col>{sources.detailPanel.data.last_week_click_counts}</Col>
                </Row>
                <Row>
                  <Col sm="6">Posts:</Col>
                  <Col>{sources.detailPanel.data.last_week_click_counts}</Col>
                </Row>
              </Col>
              <Col sm="12" md="4">
                <Row>
                  <Col sm="6">Exclude Matches:</Col>
                  <Col>{sources.detailPanel.data.blacklist_matches}</Col>
                </Row>
                <Row>
                  <Col sm="6">Include Matches:</Col>
                  <Col>{sources.detailPanel.data.whitelist_matches}</Col>
                </Row>
                <Row>
                  <Col sm="6">Evergreen Date:</Col>
                  <Col>{sources.detailPanel.data.evergreen_date}</Col>
                </Row>
                <Row>
                  <Col sm="6">Last Success:</Col>
                  <Col>{sources.detailPanel.data.last_success}</Col>
                </Row>
                <Row>
                  <Col sm="6">Last Failure:</Col>
                  <Col>{sources.detailPanel.data.last_failure}</Col>
                </Row>
              </Col>
            </Row>
          </span>
        }
        {!sources.detailPanel.data &&
          <h3>Please select a Row from above for more details.</h3>
        }
      </span>
    </DetailPanel.DetailPanel>
  }
  <AddModalConnect />
  <ImportSourceModal modal={sources.modalImport} helpText={Constants.SOURCE_IMPORT_HELP_TEXT} />
  <FilterGroup.UncontrolledCreateFilterModal
      modal={sources.modalAddFilters}
      showModal={() => dispatch(Actions.toggleAddFilterModal())}
      submitModal={(communityId: string, data: FilterGroup.ModalData) =>
        dispatch(Actions.createFilterGroup(communityId, data))}
      updateModal={(f) => dispatch(Actions.updateAddFilterModalField(f))}
      />
</div>

export const Sources = connect(
  ({sources, userMenu, app}: Props) => ({sources, userMenu, app}),
  (dispatch: any) => ({dispatch}),
)(SourceGrid)



// WEBPACK FOOTER //
// ./src/pages/sources/component.tsx